import TidalEffect from "effects/midi/TidalEffect.js";

export default superclass => class extends superclass  {
    tidals = [];

    useTidal() {
        let tidal = this.tidals.find(x => !x.inUse);

        if (tidal) {
            tidal.inUse = true;
            return tidal;
        }

        tidal = new TidalEffect(this.track, this);
        tidal.inUse = true;
        this.tidals = [...this.tidals, tidal];
        return tidal;
    }

    freeTidals() {
        this.tidals.forEach(
            t => {
                if (t.inUse) {
                    t.lastUsed = 0;
                } else {
                    t.lastUsed = (t.lastUsed || 0) + 1;
                }
                t.inUse = false;
            });
    }

    getTidalsInUse() {
        return this.tidals.filter(
            t => t.inUse);

    }
}
